(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["age-popup"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('age-popup')) {
		class AgePopup extends HTMLElement {
			connectedCallback() {
				if (this._initialized) return
				this._initialized = true

				this.storageKey = 'theme:age-verified'

				if (Shopify.designMode) {
					this.setAttribute('hidden', '')
					return
				}

				if (localStorage.getItem(this.storageKey) === 'true') {
					this.setAttribute('hidden', '')
					return
				}

				this.removeAttribute('hidden')
				document.documentElement.classList.add('lock')

				this.querySelector('.age-popup__actions')?.addEventListener('click', (event) => {
					const trigger = event.target.closest('[data-action]')

					if (!trigger) return

					if (trigger.dataset.action === 'accept') {
						this.accept()
					}

					if (trigger.dataset.action === 'decline') {
						this.decline()
					}
				})
			}

			accept() {
				localStorage.setItem(this.storageKey, 'true')
				this.close()
			}

			decline() {
				const url = this.dataset.declineUrl

				if (url) {
					window.location.href = url
				}
			}

			close() {
				this.setAttribute('hidden', '')
				document.documentElement.classList.remove('lock')
			}
		}

		customElements.define('age-popup', AgePopup)
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-events-blog"] && !Shopify.designMode) return;
  try {
    
	const initEventsBlogFilterScroll = () => {
		document.querySelectorAll('[data-events-blog-filters]').forEach((filters) => {
			if (filters.dataset.scrollInitialized) return
			filters.dataset.scrollInitialized = 'true'

			const storageKey = 'events-blog-scroll-to-filters'

			const scrollToFilters = (behavior = 'auto') => {
				const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches

				filters.scrollIntoView({
					block: 'start',
					behavior: prefersReducedMotion ? 'auto' : behavior,
				})
			}

			filters
				.closest('.shopify-section')
				?.querySelectorAll('.events-blog__filters a[href]')
				.forEach((link) => {
					link.addEventListener('click', () => {
						sessionStorage.setItem(storageKey, filters.id)
					})
				})

			const shouldScroll =
				window.location.hash === `#${filters.id}` || sessionStorage.getItem(storageKey) === filters.id

			if (!shouldScroll) return

			sessionStorage.removeItem(storageKey)
			requestAnimationFrame(() => scrollToFilters('smooth'))
		})
	}

	const initEventsBlogEditorTags = () => {
		document.querySelectorAll('[data-events-blog-editor-tags]').forEach((panel) => {
			if (panel.dataset.initialized) return
			panel.dataset.initialized = 'true'

			const feedback = panel.querySelector('[data-events-blog-editor-tags-feedback]')

			panel.addEventListener('click', async (event) => {
				const button = event.target.closest('[data-tag]')
				if (!button) return

				const tag = button.dataset.tag
				if (!tag) return

				try {
					await navigator.clipboard.writeText(tag)
				} catch {
					const textarea = document.createElement('textarea')
					textarea.value = tag
					textarea.setAttribute('readonly', '')
					textarea.style.position = 'absolute'
					textarea.style.left = '-9999px'
					document.body.appendChild(textarea)
					textarea.select()
					document.execCommand('copy')
					textarea.remove()
				}

				if (feedback) {
					feedback.hidden = false
					window.clearTimeout(feedback._hideTimeout)
					feedback._hideTimeout = window.setTimeout(() => {
						feedback.hidden = true
					}, 2000)
				}
			})
		})
	}

	initEventsBlogFilterScroll()
	initEventsBlogEditorTags()
	document.addEventListener('shopify:section:load', initEventsBlogFilterScroll)
	document.addEventListener('shopify:section:load', initEventsBlogEditorTags)

  } catch(e) { console.error(e); }
})();
})();
